module.exports = __webpack_public_path__ + "static/img/prod_pic10.fdc7c88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/prod_pic10.jpg
// module id = a3q5
// module chunks = 5